"use strict";

exports.__esModule = true;
exports.getWorkdayShifts = getWorkdayShifts;
/**
 * Given a key using key.key.indexor[0].key extract the value from the object
 */
function getWorkdayShifts(currentWorkday) {
  if (!currentWorkday.events || currentWorkday.events.length === 0) {
    return [];
  }
  var shiftArray = currentWorkday.events.filter(function (item) {
    return item.type === "Shift";
  }).map(function (item) {
    return {
      name: item.payload.name,
      interval: item.interval
    };
  });
  var returnArray = [];
  shiftArray.forEach(function (shift) {
    var found = returnArray.some(function (el) {
      return el.name === shift.name;
    });
    if (!found) {
      returnArray.push(shift);
    }
  });
  return returnArray;
}